module.exports = __webpack_public_path__ + "static/media/03_4.ebae38ed.png";